import { render, staticRenderFns } from "./c-Group.vue?vue&type=template&id=7885666c&scoped=true&"
import script from "./c-Group.vue?vue&type=script&lang=js&"
export * from "./c-Group.vue?vue&type=script&lang=js&"
import style0 from "./c-Group.vue?vue&type=style&index=0&id=7885666c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7885666c",
  null
  
)

export default component.exports